import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { bankAccountsApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useDeleteBankAccount = (options?: UseMutationOptions<void, unknown, string>) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, string>(
    ['delete-bank-account', assetId],
    async (expenseId: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await bankAccountsApi.bankAccountsControllerDelete(expenseId, assetId);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['fetch-bank-accounts', assetId]);
        trackEvent('BankAccount', 'delete');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
